import { render, staticRenderFns } from "./ResetPasswordValidate.vue?vue&type=template&id=33ec6b25&"
import script from "./ResetPasswordValidate.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordValidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports